import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-template1',
  templateUrl: './template1.component.html',
  styleUrls: ['./template1.component.scss']
})
export class Template1Component implements OnInit {

  template1Bar = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    datasets: [
        {
            label: 'My First dataset',
            backgroundColor: '#42A5F5',
            borderColor: '#1E88E5',
            data: [65, 59, 80, 81, 56, 55, 40]
        },
        {
            label: 'My Second dataset',
            backgroundColor: '#9CCC65',
            borderColor: '#7CB342',
            data: [28, 48, 40, 19, 86, 27, 90]
        }
    ]
  }
  template1BarData = [
    {
      "id":1,
      "name":"test1",
      "code":"test1",
      "category":"test1",
      "quantity":"test1"
    },
    {
      "id":2,
      "name":"test2",
      "code":"test2",
      "category":"test2",
      "quantity":"test2"
    },
    {
      "id":3,
      "name":"test3",
      "code":"test3",
      "category":"test3",
      "quantity":"test3"
    },
    {
      "id":4,
      "name":"test4",
      "code":"test4",
      "category":"test4",
      "quantity":"test4"
    },
    {
      "id":5,
      "name":"test5",
      "code":"test5",
      "category":"test5",
      "quantity":"test5"
    },
    {
      "id":6,
      "name":"test6",
      "code":"test6",
      "category":"test6",
      "quantity":"test6"
    },
    {
      "id":7,
      "name":"test7",
      "code":"test7",
      "category":"test7",
      "quantity":"test7"
    },
  ]

  displayBarDetail = false;
  selectedBarData;
  selectedBarLabel;
  selectedBarDataLabel;

  constructor() { }

  ngOnInit(): void {
  }

  selectBarData(event){
    this.displayBarDetail = true;
    this.selectedBarData = this.template1Bar.datasets[event.element._datasetIndex].data[event.element._index];
    this.selectedBarLabel = this.template1Bar.labels[event.element._index];
    this.selectedBarDataLabel = this.template1Bar.datasets[event.element._datasetIndex].label;
  }

}
